var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFbimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.2525 22.5V13.7925H19.1688L19.605 10.4075H16.2525V8.2475C16.2525 7.2675 16.525 6.59875 17.93 6.59875H19.7225V3.57125C18.8547 3.47918 17.9826 3.43453 17.11 3.4375C14.5262 3.4375 12.7575 5.015 12.7575 7.9125V10.4075H9.835V13.7925H12.7575V22.5H2C1.66848 22.5 1.35054 22.3683 1.11612 22.1339C0.881696 21.8995 0.75 21.5815 0.75 21.25V1.25C0.75 0.918479 0.881696 0.600537 1.11612 0.366116C1.35054 0.131696 1.66848 0 2 0H22C22.3315 0 22.6495 0.131696 22.8839 0.366116C23.1183 0.600537 23.25 0.918479 23.25 1.25V21.25C23.25 21.5815 23.1183 21.8995 22.8839 22.1339C22.6495 22.3683 22.3315 22.5 22 22.5H16.2525Z",
    fill: "#7A7A7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbimg);
export default __webpack_public_path__ + "static/media/fbimg.cdedf6f014baa4c88b3179ac90ae9ae7.svg";
export { ForwardRef as ReactComponent };